export default __webpack_public_path__ + "static/media/507.c0ca39d6.png";